import * as z from "zod";

export const upsertTrackingPageGlobalSettings = {
  name: "upsertTrackingPageGlobalSettings" as const,
  input: z.object({
    loadingBackgroundColor: z.string().optional(),
    hideNavigation: z.boolean().optional(),
    hideNavbar: z.boolean().optional(),
  }),
  output: z.object({
    loadingBackgroundColor: z.string().optional(),
    hideNavigation: z.boolean().optional(),
    hideNavbar: z.boolean().optional(),
  }),
};
